/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * different kinds, how to assess and grade a submission to a task
 */
export type TaskGradingSystem = (typeof TaskGradingSystem)[keyof typeof TaskGradingSystem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskGradingSystem = {
  pass_fail: 'pass_fail',
  full_evaluation: 'full_evaluation',
  threshold: 'threshold',
} as const;
